// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/venue/venue.proto (package aurora.core.apiengine.venuev1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PbAgreementInfo, PbCompanyInfo, PbInstrument, PbInstrumentInfo, RateType } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import type { Side } from "../../../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../../../consts/commonconsts_pb";
import type { OmsOrderStatus, OmsOrderType, OrderIntent } from "../../../../consts/omsconsts_pb";
import { file_consts_omsconsts } from "../../../../consts/omsconsts_pb";
import type { SettlementType } from "../../../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../../../consts/settlementconsts_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Agreement, OrderAgreement } from "../agreements/agreements_pb";
import { file_modules_apiengine_services_agreements_agreements } from "../agreements/agreements_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/venue/venue.proto.
 */
export const file_modules_apiengine_services_venue_venue: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_protos_types, file_consts_commonconsts, file_consts_omsconsts, file_consts_settlementconsts, file_google_protobuf_empty, file_modules_apiengine_services_agreements_agreements]);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryOrderBookRequest
 */
export type QueryOrderBookRequest = Message<"aurora.core.apiengine.venuev1.QueryOrderBookRequest"> & {
  /**
   * Cusip or Ticker of the queried instruments
   *
   * @generated from field: repeated string instruments = 1;
   */
  instruments: string[];

  /**
   * use side to limit the search to `best bids` or `best asks`
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 2;
   */
  side?: Side;

  /**
   * optionally restrict query to MARKET or LIMIT orders
   *
   * @generated from field: optional aurora.core.consts.oms.OmsOrderType order_type = 3;
   */
  orderType?: OmsOrderType;

  /**
   * optionally restrict query to orders with a minimum requested quantity
   *
   * @generated from field: optional int64 minimum_quantity = 4;
   */
  minimumQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum requested quantity
   *
   * @generated from field: optional int64 maximum_quantity = 5;
   */
  maximumQuantity?: bigint;

  /**
   * rate type to use when restricting orders by minimum_rate or maximum_rate
   *
   * @generated from field: optional aurora.core.common.protos.RateType rate_type = 6;
   */
  rateType?: RateType;

  /**
   * optionally restrict query to orders with minimum requested fee
   *
   * @generated from field: optional string minimum_fee = 7;
   */
  minimumFee?: string;

  /**
   * optionally restrict query to orders with maximum requested fee
   *
   * @generated from field: optional string maximum_fee = 8;
   */
  maximumFee?: string;

  /**
   * optionally restrict query to orders with minimum requested rebate
   *
   * @generated from field: optional string minimum_rebate = 9;
   */
  minimumRebate?: string;

  /**
   * optionally restrict query to orders with maximum requested rebate
   *
   * @generated from field: optional string maximum_rebate = 10;
   */
  maximumRebate?: string;

  /**
   * optionally restrict query to orders with a minimum min execution quantity
   *
   * @generated from field: optional int64 minimum_min_execution_quantity = 11;
   */
  minimumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum min execution quantity
   *
   * @generated from field: optional int64 maximum_min_execution_quantity = 12;
   */
  maximumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with specific agreements
   *
   * @generated from field: repeated string agreement_ids = 13;
   */
  agreementIds: string[];

  /**
   * optionally restrict query to orders created by a set of companies
   *
   * @generated from field: repeated string company_ids = 14;
   */
  companyIds: string[];

  /**
   * Page number, 1 being the starting one. Required if page_limit is set.
   *
   * @generated from field: optional int32 page_number = 15;
   */
  pageNumber?: number;

  /**
   * Number of orders per page (max 20,000). Required if page_number is set. Defaults to 1,000 if not set.
   *
   * @generated from field: optional int32 page_limit = 16;
   */
  pageLimit?: number;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryOrderBookRequest.
 * Use `create(QueryOrderBookRequestSchema)` to create a new message.
 */
export const QueryOrderBookRequestSchema: GenMessage<QueryOrderBookRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 0);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryOrderBookResponse
 */
export type QueryOrderBookResponse = Message<"aurora.core.apiengine.venuev1.QueryOrderBookResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.venuev1.Order orders = 1;
   */
  orders: Order[];
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryOrderBookResponse.
 * Use `create(QueryOrderBookResponseSchema)` to create a new message.
 */
export const QueryOrderBookResponseSchema: GenMessage<QueryOrderBookResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 1);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryOrderBookDetailedRequest
 */
export type QueryOrderBookDetailedRequest = Message<"aurora.core.apiengine.venuev1.QueryOrderBookDetailedRequest"> & {
  /**
   * Cusip or Ticker of the queried instrument
   *
   * @generated from field: optional string instrument = 1;
   */
  instrument?: string;

  /**
   * use side to limit the search to `best bids` or `best asks`
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 2;
   */
  side?: Side;

  /**
   * optionally restrict query to MARKET or LIMIT orders
   *
   * @generated from field: optional aurora.core.consts.oms.OmsOrderType order_type = 3;
   */
  orderType?: OmsOrderType;

  /**
   * optionally restrict query to orders with a minimum requested quantity
   *
   * @generated from field: optional int64 minimum_quantity = 6;
   */
  minimumQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum requested quantity
   *
   * @generated from field: optional int64 maximum_quantity = 7;
   */
  maximumQuantity?: bigint;

  /**
   * rate type to use when restricting orders by minimum_rate or maximum_rate
   *
   * @generated from field: optional aurora.core.common.protos.RateType rate_type = 13;
   */
  rateType?: RateType;

  /**
   * optionally restrict query to orders with minimum requested fee
   *
   * @generated from field: optional string minimum_fee = 8;
   */
  minimumFee?: string;

  /**
   * optionally restrict query to orders with maximum requested fee
   *
   * @generated from field: optional string maximum_fee = 9;
   */
  maximumFee?: string;

  /**
   * optionally restrict query to orders with minimum requested rebate
   *
   * @generated from field: optional string minimum_rebate = 15;
   */
  minimumRebate?: string;

  /**
   * optionally restrict query to orders with maximum requested rebate
   *
   * @generated from field: optional string maximum_rebate = 16;
   */
  maximumRebate?: string;

  /**
   * optionally restrict query to orders with a minimum requested quantity
   *
   * @generated from field: optional int64 minimum_min_execution_quantity = 10;
   */
  minimumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum requested quantity
   *
   * @generated from field: optional int64 maximum_min_execution_quantity = 11;
   */
  maximumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with specific agreements
   *
   * @generated from field: repeated string agreement_ids = 12;
   */
  agreementIds: string[];

  /**
   * optionally restrict query to orders created by a set of companies
   *
   * @generated from field: repeated string company_ids = 14;
   */
  companyIds: string[];

  /**
   * Page number, 1 being the starting one. Required if page_limit is set.
   *
   * @generated from field: optional int32 page_number = 17;
   */
  pageNumber?: number;

  /**
   * Number of orders per page (max 20,000). Required if page_number is set. Defaults to 1,000 if not set.
   *
   * @generated from field: optional int32 page_limit = 18;
   */
  pageLimit?: number;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryOrderBookDetailedRequest.
 * Use `create(QueryOrderBookDetailedRequestSchema)` to create a new message.
 */
export const QueryOrderBookDetailedRequestSchema: GenMessage<QueryOrderBookDetailedRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 2);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryOrderBookDetailedResponse
 */
export type QueryOrderBookDetailedResponse = Message<"aurora.core.apiengine.venuev1.QueryOrderBookDetailedResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.venuev1.OrderDetailed orders = 1;
   */
  orders: OrderDetailed[];
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryOrderBookDetailedResponse.
 * Use `create(QueryOrderBookDetailedResponseSchema)` to create a new message.
 */
export const QueryOrderBookDetailedResponseSchema: GenMessage<QueryOrderBookDetailedResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 3);

/**
 * @generated from message aurora.core.apiengine.venuev1.ListChildOrdersRequest
 */
export type ListChildOrdersRequest = Message<"aurora.core.apiengine.venuev1.ListChildOrdersRequest"> & {
  /**
   * @generated from field: string parent_id = 1;
   */
  parentId: string;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.ListChildOrdersRequest.
 * Use `create(ListChildOrdersRequestSchema)` to create a new message.
 */
export const ListChildOrdersRequestSchema: GenMessage<ListChildOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 4);

/**
 * @generated from message aurora.core.apiengine.venuev1.ListChildOrdersResponse
 */
export type ListChildOrdersResponse = Message<"aurora.core.apiengine.venuev1.ListChildOrdersResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.venuev1.VenueOrderForOms orders = 1;
   */
  orders: VenueOrderForOms[];
};

/**
 * Describes the message aurora.core.apiengine.venuev1.ListChildOrdersResponse.
 * Use `create(ListChildOrdersResponseSchema)` to create a new message.
 */
export const ListChildOrdersResponseSchema: GenMessage<ListChildOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 5);

/**
 * Venue order for OMS
 *
 * @generated from message aurora.core.apiengine.venuev1.VenueOrderForOms
 */
export type VenueOrderForOms = Message<"aurora.core.apiengine.venuev1.VenueOrderForOms"> & {
  /**
   * Provable Markets assigned order identifier for the order event notification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Cusip of the instrument
   *
   * @generated from field: string cusip = 2;
   */
  cusip: string;

  /**
   * Ticker of the instrument
   *
   * @generated from field: string ticker = 3;
   */
  ticker: string;

  /**
   * oms identifier of this order
   *
   * @generated from field: string client_order_ref = 4;
   */
  clientOrderRef: string;

  /**
   * Company ID owning  the order
   *
   * @generated from field: string company_id = 5;
   */
  companyId: string;

  /**
   * agreements that the order can be matched under
   *
   * @generated from field: repeated string agreement_ids = 6;
   */
  agreementIds: string[];

  /**
   * borrow or lend- order
   *
   * @generated from field: aurora.core.consts.common.Side side = 7;
   */
  side: Side;

  /**
   * Requested quantity of shares
   *
   * @generated from field: int64 total_quantity = 8;
   */
  totalQuantity: bigint;

  /**
   * remaining quantity of shares
   *
   * @generated from field: int64 open_quantity = 9;
   */
  openQuantity: bigint;

  /**
   * Minimum quantity of shares per execution - optional, defaults to 100
   *
   * @generated from field: optional int64 min_execution_quantity = 10;
   */
  minExecutionQuantity?: bigint;

  /**
   * Rate for the order expressed as fee
   *
   * @generated from field: optional string fee = 11;
   */
  fee?: string;

  /**
   * Rate for the order expressed as rebate
   *
   * @generated from field: optional string rebate = 12;
   */
  rebate?: string;

  /**
   * Time In Force type (e.g. day, gtc, fok, ioc)
   *
   * @generated from field: string time_in_force = 13;
   */
  timeInForce: string;

  /**
   * The time the order will be canceled if populated.
   *
   * @generated from field: optional string good_till_time = 14;
   */
  goodTillTime?: string;

  /**
   * Order type of the order - time in RFC3339 with millisecond precision
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 15;
   */
  orderType: OmsOrderType;

  /**
   * The current status of the order.
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderStatus order_status = 16;
   */
  orderStatus: OmsOrderStatus;

  /**
   * Order created at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 17;
   */
  createdAt: string;

  /**
   * Order was last changed at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 18;
   */
  updatedAt: string;

  /**
   * shares executed on order so far
   *
   * @generated from field: int64 total_execution_quantity = 19;
   */
  totalExecutionQuantity: bigint;

  /**
   * The intent of the order (FIRM, IOI)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 20;
   */
  orderIntent: OrderIntent;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.VenueOrderForOms.
 * Use `create(VenueOrderForOmsSchema)` to create a new message.
 */
export const VenueOrderForOmsSchema: GenMessage<VenueOrderForOms> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 6);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceRequest
 */
export type QueryMarketplaceRequest = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceRequest"> & {
  /**
   * Filters for borrow orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter borrow_filter = 1;
   */
  borrowFilter?: QueryMarketplaceFilter;

  /**
   * Filters for lend orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter lend_filter = 2;
   */
  lendFilter?: QueryMarketplaceFilter;

  /**
   * change the view based on the user's intention to borrow or lend
   *
   * @generated from field: aurora.core.consts.common.Side trade_intention = 3;
   */
  tradeIntention: Side;

  /**
   * Page number, 1 being the starting one
   *
   * @generated from field: optional int32 page_number = 4;
   */
  pageNumber?: number;

  /**
   * Number of orders per page
   *
   * @generated from field: optional int32 page_limit = 5;
   */
  pageLimit?: number;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceRequest.
 * Use `create(QueryMarketplaceRequestSchema)` to create a new message.
 */
export const QueryMarketplaceRequestSchema: GenMessage<QueryMarketplaceRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 7);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceResponse
 */
export type QueryMarketplaceResponse = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceResponse"> & {
  /**
   * List of borrow and lend order pairs
   *
   * @generated from field: repeated aurora.core.apiengine.venuev1.QueryMarketplaceItem items = 1;
   */
  items: QueryMarketplaceItem[];

  /**
   * Instruments used for the orders
   *
   * @generated from field: map<string, aurora.core.common.protos.PbInstrumentInfo> instruments = 2;
   */
  instruments: { [key: string]: PbInstrumentInfo };

  /**
   * Companies used for the orders
   *
   * @generated from field: map<string, aurora.core.common.protos.PbCompanyInfo> companies = 3;
   */
  companies: { [key: string]: PbCompanyInfo };

  /**
   * Agreements used for orders
   *
   * @generated from field: map<string, aurora.core.common.protos.PbAgreementInfo> agreements = 4;
   */
  agreements: { [key: string]: PbAgreementInfo };
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceResponse.
 * Use `create(QueryMarketplaceResponseSchema)` to create a new message.
 */
export const QueryMarketplaceResponseSchema: GenMessage<QueryMarketplaceResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 8);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceItem
 */
export type QueryMarketplaceItem = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceItem"> & {
  /**
   * Borrow side order of the pair
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.BookOrder borrow_order = 1;
   */
  borrowOrder?: BookOrder;

  /**
   * Lend side order of the pair
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.BookOrder lend_order = 2;
   */
  lendOrder?: BookOrder;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceItem.
 * Use `create(QueryMarketplaceItemSchema)` to create a new message.
 */
export const QueryMarketplaceItemSchema: GenMessage<QueryMarketplaceItem> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 9);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceFilter
 */
export type QueryMarketplaceFilter = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceFilter"> & {
  /**
   * Cusip or Ticker of the queried instruments
   *
   * @generated from field: repeated string instruments = 1;
   */
  instruments: string[];

  /**
   * optionally restrict query to LIMIT orders
   *
   * @generated from field: optional aurora.core.consts.oms.OmsOrderType order_type = 2;
   */
  orderType?: OmsOrderType;

  /**
   * optionally restrict query to orders with a minimum requested quantity
   *
   * @generated from field: optional int64 minimum_quantity = 5;
   */
  minimumQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum requested quantity
   *
   * @generated from field: optional int64 maximum_quantity = 6;
   */
  maximumQuantity?: bigint;

  /**
   * optionally restrict query to orders with minimum requested rebate
   *
   * @generated from field: optional string minimum_rebate = 16;
   */
  minimumRebate?: string;

  /**
   * optionally restrict query to orders with maximum requested rebate
   *
   * @generated from field: optional string maximum_rebate = 17;
   */
  maximumRebate?: string;

  /**
   * optionally restrict query to orders with minimum requested fee
   *
   * @generated from field: optional string minimum_fee = 7;
   */
  minimumFee?: string;

  /**
   * optionally restrict query to orders with maximum requested fee
   *
   * @generated from field: optional string maximum_fee = 8;
   */
  maximumFee?: string;

  /**
   * optionally restrict query to orders with a minimum execution quantity
   *
   * @generated from field: optional int64 minimum_min_execution_quantity = 9;
   */
  minimumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with a maximum execution quantity
   *
   * @generated from field: optional int64 maximum_min_execution_quantity = 10;
   */
  maximumMinExecutionQuantity?: bigint;

  /**
   * optionally restrict query to orders with agreement
   *
   * @generated from field: repeated string agreement_ids = 11;
   */
  agreementIds: string[];

  /**
   * optionally restrict query to orders with counterparty
   *
   * @generated from field: repeated string counterparty_ids = 12;
   */
  counterpartyIds: string[];

  /**
   * optionally restrict query to orders with settlement type
   *
   * @generated from field: optional aurora.core.consts.settlement.SettlementType settlement_type = 13;
   */
  settlementType?: SettlementType;

  /**
   * to be used in combination with minimum_rate / maximum_rate
   *
   * @generated from field: optional aurora.core.common.protos.RateType rate_type = 14;
   */
  rateType?: RateType;

  /**
   * optionally restrict query to include own orders or not
   *
   * @generated from field: optional bool own_orders = 15;
   */
  ownOrders?: boolean;

  /**
   * optionally restrict query to FIRM or IOI orders
   *
   * @generated from field: optional aurora.core.consts.oms.OrderIntent order_intent = 18;
   */
  orderIntent?: OrderIntent;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceFilter.
 * Use `create(QueryMarketplaceFilterSchema)` to create a new message.
 */
export const QueryMarketplaceFilterSchema: GenMessage<QueryMarketplaceFilter> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 10);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsRequest
 */
export type QueryMarketplaceInstrumentsRequest = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsRequest"> & {
  /**
   * Filters for borrow orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter borrow_filter = 1;
   */
  borrowFilter?: QueryMarketplaceFilter;

  /**
   * Filters for lend orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter lend_filter = 2;
   */
  lendFilter?: QueryMarketplaceFilter;

  /**
   * change the view based on the user's intention to borrow or lend
   *
   * @generated from field: aurora.core.consts.common.Side trade_intention = 3;
   */
  tradeIntention: Side;

  /**
   * show instruments that the user has orders for
   *
   * @generated from field: optional bool own_instruments = 4;
   */
  ownInstruments?: boolean;

  /**
   * show instruments that counterparties have orders for
   *
   * @generated from field: optional bool counterparty_instruments = 5;
   */
  counterpartyInstruments?: boolean;

  /**
   * optionally restrict query to instruments with watchlist
   *
   * @generated from field: optional string watchlist_display_id = 6;
   */
  watchlistDisplayId?: string;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsRequest.
 * Use `create(QueryMarketplaceInstrumentsRequestSchema)` to create a new message.
 */
export const QueryMarketplaceInstrumentsRequestSchema: GenMessage<QueryMarketplaceInstrumentsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 11);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceInstrument
 */
export type QueryMarketplaceInstrument = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceInstrument"> & {
  /**
   * Instrument details
   *
   * @generated from field: aurora.core.common.protos.PbInstrumentInfo instrument = 1;
   */
  instrument?: PbInstrumentInfo;

  /**
   * Number of orders for the instrument
   *
   * @generated from field: int64 order_count = 2;
   */
  orderCount: bigint;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceInstrument.
 * Use `create(QueryMarketplaceInstrumentSchema)` to create a new message.
 */
export const QueryMarketplaceInstrumentSchema: GenMessage<QueryMarketplaceInstrument> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 12);

/**
 * @generated from message aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsResponse
 */
export type QueryMarketplaceInstrumentsResponse = Message<"aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.venuev1.QueryMarketplaceInstrument instruments = 1;
   */
  instruments: QueryMarketplaceInstrument[];
};

/**
 * Describes the message aurora.core.apiengine.venuev1.QueryMarketplaceInstrumentsResponse.
 * Use `create(QueryMarketplaceInstrumentsResponseSchema)` to create a new message.
 */
export const QueryMarketplaceInstrumentsResponseSchema: GenMessage<QueryMarketplaceInstrumentsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 13);

/**
 * single order in the depth-of-book
 *
 * @generated from message aurora.core.apiengine.venuev1.BookOrder
 */
export type BookOrder = Message<"aurora.core.apiengine.venuev1.BookOrder"> & {
  /**
   * borrow or lend- order
   *
   * @generated from field: aurora.core.consts.common.Side side = 1;
   */
  side: Side;

  /**
   * Requested quantity of shares
   *
   * @generated from field: int64 quantity = 2;
   */
  quantity: bigint;

  /**
   * Rate for the order expressed as fee
   *
   * @generated from field: optional string fee = 4;
   */
  fee?: string;

  /**
   * Rate for the order expressed as rebate
   *
   * @generated from field: optional string rebate = 19;
   */
  rebate?: string;

  /**
   * Minimum quantity of shares per execution - optional, defaults to 100
   *
   * @generated from field: optional int64 min_execution_quantity = 7;
   */
  minExecutionQuantity?: bigint;

  /**
   * Order type of the order
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 8;
   */
  orderType: OmsOrderType;

  /**
   * agreements that the order can be matched under
   *
   * @generated from field: repeated string agreement_ids = 11;
   */
  agreementIds: string[];

  /**
   * Cusip of the instrument
   *
   * @generated from field: string cusip = 17;
   */
  cusip: string;

  /**
   * Ticker of the instrument
   *
   * @generated from field: string ticker = 18;
   */
  ticker: string;

  /**
   * Company ID for the order
   *
   * @generated from field: string company_id = 12;
   */
  companyId: string;

  /**
   * Market value
   *
   * @generated from field: string market_value = 13;
   */
  marketValue: string;

  /**
   * Root client order reference
   *
   * @generated from field: string root_client_order_ref = 14;
   */
  rootClientOrderRef: string;

  /**
   * Client order referenchanged
   *
   * @generated from field: string client_order_ref = 15;
   */
  clientOrderRef: string;

  /**
   * Active
   *
   * @generated from field: bool active = 16;
   */
  active: boolean;

  /**
   * The intent of the order (FIRM, IOI)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 20;
   */
  orderIntent: OrderIntent;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.BookOrder.
 * Use `create(BookOrderSchema)` to create a new message.
 */
export const BookOrderSchema: GenMessage<BookOrder> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 14);

/**
 * @generated from message aurora.core.apiengine.venuev1.OrderDetailed
 */
export type OrderDetailed = Message<"aurora.core.apiengine.venuev1.OrderDetailed"> & {
  /**
   * reference of the order
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * borrow or lend- order
   *
   * @generated from field: aurora.core.consts.common.Side side = 2;
   */
  side: Side;

  /**
   * Requested quantity of shares
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Cusip or Ticker of instrument
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 4;
   */
  instrument?: PbInstrument;

  /**
   * Fee
   *
   * @generated from field: optional string fee = 5;
   */
  fee?: string;

  /**
   * Rebate
   *
   * @generated from field: optional string rebate = 6;
   */
  rebate?: string;

  /**
   * Minimum quantity of shares per execution
   *
   * @generated from field: int64 min_quantity = 7;
   */
  minQuantity: bigint;

  /**
   * Order type of the order
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 8;
   */
  orderType: OmsOrderType;

  /**
   * agreements that the order can be matched under
   *
   * @generated from field: repeated aurora.core.apiengine.agreementsv1.Agreement agreements = 9;
   */
  agreements: Agreement[];

  /**
   * Company ID for the order
   *
   * @generated from field: string company_id = 10;
   */
  companyId: string;

  /**
   * The intent of the order (FIRM, IOI)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 11;
   */
  orderIntent: OrderIntent;

  /**
   * time at which order was created - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * time at which order was last updated at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.OrderDetailed.
 * Use `create(OrderDetailedSchema)` to create a new message.
 */
export const OrderDetailedSchema: GenMessage<OrderDetailed> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 15);

/**
 * @generated from message aurora.core.apiengine.venuev1.Order
 */
export type Order = Message<"aurora.core.apiengine.venuev1.Order"> & {
  /**
   * reference of the order
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * borrow or lend- order
   *
   * @generated from field: aurora.core.consts.common.Side side = 2;
   */
  side: Side;

  /**
   * Requested quantity of shares
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Cusip or Ticker of instrument
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 4;
   */
  instrument?: PbInstrument;

  /**
   * Fee
   *
   * @generated from field: optional string fee = 5;
   */
  fee?: string;

  /**
   * Rebate
   *
   * @generated from field: optional string rebate = 6;
   */
  rebate?: string;

  /**
   * Minimum quantity of shares per execution
   *
   * @generated from field: int64 min_quantity = 7;
   */
  minQuantity: bigint;

  /**
   * Order type of the order
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 8;
   */
  orderType: OmsOrderType;

  /**
   * agreements that the order can be matched under
   *
   * @generated from field: repeated aurora.core.apiengine.agreementsv1.OrderAgreement agreements = 9;
   */
  agreements: OrderAgreement[];

  /**
   * Company ID for the order
   *
   * @generated from field: string company_id = 10;
   */
  companyId: string;

  /**
   * The intent of the order (FIRM, IOI)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 11;
   */
  orderIntent: OrderIntent;

  /**
   * time at which order was created - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * time at which order was last updated at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 16);

/**
 * @generated from message aurora.core.apiengine.venuev1.OrderAddedEvent
 */
export type OrderAddedEvent = Message<"aurora.core.apiengine.venuev1.OrderAddedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.venuev1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.OrderAddedEvent.
 * Use `create(OrderAddedEventSchema)` to create a new message.
 */
export const OrderAddedEventSchema: GenMessage<OrderAddedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 17);

/**
 * @generated from message aurora.core.apiengine.venuev1.OrderRemovedEvent
 */
export type OrderRemovedEvent = Message<"aurora.core.apiengine.venuev1.OrderRemovedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.venuev1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.OrderRemovedEvent.
 * Use `create(OrderRemovedEventSchema)` to create a new message.
 */
export const OrderRemovedEventSchema: GenMessage<OrderRemovedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 18);

/**
 * @generated from message aurora.core.apiengine.venuev1.ExportMarketplaceRequest
 */
export type ExportMarketplaceRequest = Message<"aurora.core.apiengine.venuev1.ExportMarketplaceRequest"> & {
  /**
   * Filters for borrow orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter borrow_filter = 1;
   */
  borrowFilter?: QueryMarketplaceFilter;

  /**
   * Filters for lend orders
   *
   * @generated from field: optional aurora.core.apiengine.venuev1.QueryMarketplaceFilter lend_filter = 2;
   */
  lendFilter?: QueryMarketplaceFilter;

  /**
   * Change the view based on the user's intention to borrow or lend
   *
   * @generated from field: aurora.core.consts.common.Side trade_intention = 3;
   */
  tradeIntention: Side;

  /**
   * Export with Fees or Rebates
   *
   * @generated from field: optional aurora.core.common.protos.RateType rate_type = 5;
   */
  rateType?: RateType;

  /**
   * Export as CSV or XLSX
   *
   * @generated from field: optional bool is_excel_sheet = 4;
   */
  isExcelSheet?: boolean;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.ExportMarketplaceRequest.
 * Use `create(ExportMarketplaceRequestSchema)` to create a new message.
 */
export const ExportMarketplaceRequestSchema: GenMessage<ExportMarketplaceRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 19);

/**
 * @generated from message aurora.core.apiengine.venuev1.ExportMarketplaceResponse
 */
export type ExportMarketplaceResponse = Message<"aurora.core.apiengine.venuev1.ExportMarketplaceResponse"> & {
  /**
   * file content
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;
};

/**
 * Describes the message aurora.core.apiengine.venuev1.ExportMarketplaceResponse.
 * Use `create(ExportMarketplaceResponseSchema)` to create a new message.
 */
export const ExportMarketplaceResponseSchema: GenMessage<ExportMarketplaceResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_venue_venue, 20);

/**
 * @generated from service aurora.core.apiengine.venuev1.VenueService
 */
export const VenueService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.QueryOrderBook
   */
  queryOrderBook: {
    methodKind: "unary";
    input: typeof QueryOrderBookRequestSchema;
    output: typeof QueryOrderBookResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.QueryOrderBookDetailed
   */
  queryOrderBookDetailed: {
    methodKind: "unary";
    input: typeof QueryOrderBookDetailedRequestSchema;
    output: typeof QueryOrderBookDetailedResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.ListChildOrders
   */
  listChildOrders: {
    methodKind: "unary";
    input: typeof ListChildOrdersRequestSchema;
    output: typeof ListChildOrdersResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.QueryMarketplace
   */
  queryMarketplace: {
    methodKind: "unary";
    input: typeof QueryMarketplaceRequestSchema;
    output: typeof QueryMarketplaceResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.QueryMarketplaceInstruments
   */
  queryMarketplaceInstruments: {
    methodKind: "unary";
    input: typeof QueryMarketplaceInstrumentsRequestSchema;
    output: typeof QueryMarketplaceInstrumentsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.venuev1.VenueService.ExportMarketplace
   */
  exportMarketplace: {
    methodKind: "unary";
    input: typeof ExportMarketplaceRequestSchema;
    output: typeof ExportMarketplaceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_venue_venue, 0);

/**
 * @generated from service aurora.core.apiengine.venuev1.VenueEventsService
 */
export const VenueEventsService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.venuev1.VenueEventsService.OrderAdded
   */
  orderAdded: {
    methodKind: "unary";
    input: typeof OrderAddedEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.venuev1.VenueEventsService.OrderRemoved
   */
  orderRemoved: {
    methodKind: "unary";
    input: typeof OrderRemovedEventSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_venue_venue, 1);

